import React from 'react';
import Login from '../Home/onboarding/login';
import {inject, observer} from 'mobx-react';
import {Link, withRouter} from 'react-router-dom';
// import { slide as Menu } from 'react-burger-menu'
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavItem,
    NavLink,
    UncontrolledDropdown
} from 'reactstrap';
import '../../styles/toolbar_fresh.css'
import ReactGA from "react-ga";
// import { threadId } from 'worker_threads';


const notifications = [
    {
        artworkImg: require('../../assets/painting1.png'),
        notification_heading: "Request approved",
        notification_content: "pay for the artwork to complete your order"
    },
]
var dropdownItem = [
    // { path: "orders", name: "Your orders", discription: "Buy and Sell on masterpieces" },
    // { path: "requests", name: "View Requests", discription: "Manage requests for private posts" },
    { path: `/profile/details/${localStorage.getItem("username")}`, name: "View Profile", discription: "See your YourMasterpieces profile" },
    { path: "edit-profile", name: "Edit Profile", discription: "Manage profile and preferences" },
    // { path: "addresses", name: "Addresses", discription: "Manage your addresses" },
    { path: "/", name: "Log Out", discription: "Log yourself out of YourMasterpieces" },
]
@inject('userStore', 'navigatorStore', 'authStore', 'commonStore', 'searchPageArtworksStore')
@withRouter
@observer
export default class toolbar_replace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toProfile: false,
            toArtworksLocal: false,
            newNotification: true,
            clickedDropdown: false,
            searched: false,
            searchedKeyword: ""
        }
    }
    handleKeyDown(event) {
        if (event.keyCode == 13 /*enter*/) {
            this.handleSearchInput(event);
        }
    }
    componentDidMount() {
        ReactGA.initialize('UA-74761806-02');
        ReactGA.pageview(window.location.pathname + window.location.search);
        this.setState({
            viewPortWidth: document.documentElement.clientWidth
        })
    }
    handleArtworksBtnClick() {
        // this.props.navigatorStore.focusToArtworksFromToolbar();
        // console.log("dumbass coming here to open signin");
        if (!localStorage.hasOwnProperty("userData")) this.props.navigatorStore.openSignInModal();
    }
    handleArtistsBtnClick() {
        // this.props.navigatorStore.focusToArtworksFromToolbar();
        // console.log("dumbass coming here to open signin");
        if (!localStorage.hasOwnProperty("userData")) this.props.navigatorStore.openSignInModal();
    }
    clickDropDownItem(item) {
        switch (item) {
            case "Log Out": {
                this.props.history.replace("/")
                this.props.authStore.logout()
            break
            };
         
        }
    }
    handelProfileClick() {
        this.setState({
            toProfile: true
        })
    }
    handleSearchInput() {
        if (this.state.searchedKeyword.length < 3) {
            this.props.navigatorStore.openErrorModal("Search text must have a minimum of 3 characters", false, null, true)
            return;
        }
        this.props.history.replace(`/searchpage/${this.state.searchedKeyword}` )
        this.setState({
            searchedKeywordFinal: this.state.searchedKeyword,
            searched: true
        }, function () {
            // console.log("final search", this.state.searchedKeywordFinal);
            // event.target.value = null
        });
    }
    handleInputChange(event) {
        this.setState({
            searchedKeyword: event.target.value
        }, function () {
            // console.log(this.state.searchedKeyword)
        })
        // this.props.commonStore.setSearchedKeyword(event.target.value)
    }
    handleDropdownClick() {
        this.setState({
            viewSecondDropdown: true
        })
    }
    handleDropdownClickDisable() {
        this.setState({
            viewSecondDropdown: false
        })
    }
    resetSearchKw() {
        this.setState({
            searchedKeyword: ""
        })
    }
    render() {
        // console.log("viewport", this.state.viewPortWidth)
        if (this.props.searchPageArtworksStore.resettingSearchkW) {
            this.resetSearchKw.bind(this)
        }
        return (
            <Navbar color="#FFFFFF" className="masterpieces-navbar"
                style={{
                    minHeight: (this.state.viewPortWidth < "768") ? "8rem"
                        // : (this.state.viewPortWidth < "768" && !localStorage.getItem("userData")) ? "4.5rem"
                        : "4rem"
                }} >
                <NewMobileView notifications={notifications}
                               handleDropdownClickDisable={this.handleDropdownClickDisable.bind(this)}
                               handleDropdownClick={this.handleDropdownClick.bind(this)}
                               viewSecondDropdown={this.state.viewSecondDropdown}
                               handleInputChange={this.handleInputChange.bind(this)}
                               handleArtistsBtnClick={this.handleArtistsBtnClick.bind(this)}
                               handleKeyDown={this.handleKeyDown.bind(this)}
                               dropdownItem={dropdownItem} currentUser={this.props.userStore.currentUser}
                               newNotification={this.state.newNotification} notifications={notifications}
                               clickDropDownItem={this.clickDropDownItem.bind(this)}
                               handleArtworksBtnClick={this.handleArtworksBtnClick.bind(this)}
                               handleSearchInput={this.handleSearchInput.bind(this)}
                />
                <Nav id="desktopView" className="ml-auto desktopViewNav" navbar>
                    <div className="masterpieces-branding-and-search-bar">
                        <NavItem className="masterpieces-navbar-items max-width-245">
                            <NavLink >
                                <Link to="/"> <img src={require('../../assets/Header_logo.png')} className="masterpieces-logo-brand-navbar" /></Link>
                            </NavLink>
                        </NavItem>
                        <NavItem className="masterpieces-navbar-items" id=" " style={{ position: "relative" }}>
                            <input style={{
                                
                                maxHeight: "36px", minHeight: "36px" }}
                                //  disabled={!localStorage.hasOwnProperty("userData")}
                                // style={{ opacity: localStorage.hasOwnProperty("userData") ? 1 : 0 }}
                                onChange={this.handleInputChange.bind(this)} 
                                // onClick={(event) => {
                                //     event.target.value = null
                                // }}
                                onKeyDown={this.handleKeyDown.bind(this)} className="navbar-searchbar" placeholder="search art, artist or art style"></input>
                            <img
                                // disabled={!localStorage.hasOwnProperty("userData")}
                                //  style={{ opacity: localStorage.hasOwnProperty("userData") ? 1 : 0, cursor: localStorage.hasOwnProperty("userData") ? "pointer" : "" }} 
                                onClick={this.handleSearchInput.bind(this)}
                                
                                alt="" className="masterpieces-search-image"  src={require('../../assets/search_icon.png')} ></img>
                        </NavItem>
                    </div>
                    <div className="masterpieces-links header-link">
                        <NavItem className="masterpieces-navbar-items">
                            <NavLink className="masterpieces-navbar-links" style={{ cursor: "default" }}
                            ><Link onClick={this.handleArtworksBtnClick.bind(this)} to={localStorage.hasOwnProperty("userData") ? "/artworks" : ""} style={{ fontWeight: (this.props.navigatorStore.isArtworksPageActive) ? "700" : "500"
                            // ,  marginLeft : "21px", 
                            }}>ARTWORKS</Link></NavLink>
                        </NavItem>
                        <NavItem className="masterpieces-navbar-items">
                            <NavLink className="masterpieces-navbar-links" style={{ cursor: "default" }}
                            ><Link to={localStorage.hasOwnProperty("userData") ? "/artists" : ""} onClick={this.handleArtistsBtnClick.bind(this)} style={{ fontWeight: (this.props.navigatorStore.isArtistPageActive) ? "700" : "500"
                            // ,  marginLeft : "60px", 
                            }}>ARTISTS</Link></NavLink>
                            {/* <NavLink style={{ marginLeft: "15%", fontWeight: this.props.navigatorStore.toArtworks ? "700" : "510", color: this.props.navigatorStore.toArtworks ? "#000000" : "#333333" }} className="navbar-links-artists" href="http://localhost:3000/#/artworks">ARTISTS</NavLink> */}
                        </NavItem>
                         <NavItem className="masterpieces-navbar-items blog-link">
                            <NavLink className="masterpieces-navbar-links" href="http://blog.yourmasterpieces.com/" target="_blank">
                                BLOG
                            </NavLink>
                        </NavItem> 
                        {/* <NavItem className="masterpieces-navbar-items">
<NavLink className="masterpieces-navbar-links" >SPOTLIGHT</NavLink>
</NavItem > */}
                        <NavItem className="masterpieces-navbar-items " style={{ flex: 2 }} >
                            <LoggedOutView currentUser={this.props.userStore.currentUser} />
                            <LoggedInView dropdownItem={dropdownItem} currentUser={this.props.userStore.currentUser} newNotification={this.state.newNotification} notifications={notifications} clickDropDownItem={this.clickDropDownItem.bind(this)} />
                        </NavItem >
                    </div>
                </Nav>
                {/* {this.state.searched && <SearchPage searchedKeyword={this.state.searchedKeyword} />} */}
                {/* {(this.state.searchedKeywordFinal) && <Redirect push to={{ pathname: `/searchpage/${this.state.searchedKeywordFinal}` }} />} */}
            </Navbar>
        )
    }
}
const LoggedInView = (props) => {
    let { item, onClickItem } = props;
    // this.userOrders = () => this.props.navigatorStore.toYourOrders();
    if (props.currentUser) {
        // console.log("logged in props.currentUser", props.currentUser);
        // var self = this
        return (
            // <div style={{ margin: "0 auto", maxWidth: "100%", backgroundColor: "#FFFFFF", marginBottom: "0%", display: "flex", flexDirection: "row" }} >
            <div style={{ display: "flex" }} >
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                        <img style={{ opacity: 0 }} className="notification-icon" src={(props.newNotification) ? require('../../assets/new_notification_icon_svg.svg') : require('../../assets/notification_icon_svg.svg')} />
                    </DropdownToggle>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav inNavbar style={{ display: "flex", flex: 1 }} >
                    <DropdownToggle nav caret>
                        <div style={{ display: "flex" }}>
                            <img alt="" className="user-photo" src={props.currentUser.image} alt="" />
                            <div className="user-name">{props.currentUser.display_name}</div>
                            <img className="notification-icon" src={require('../../assets/notification_icon copy_svg.svg')} style={{ flex: 1, marginRight: "0px" }}></img>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu className="loginDropdown">
                        <DropdownData dropdownItem={props.dropdownItem} clickDropDownItem={props.clickDropDownItem} />
                    </DropdownMenu>
                </UncontrolledDropdown>
            </div>
        );
    }
    return <span></span>;
};
const DropdownData = (props) => {
    let { dropdownItem } = props
    return (
        dropdownItem.map((el, elIndex) => <DropdownItem key={elIndex} value="item" onClick={() => props.clickDropDownItem(el.name)} >
            {
                el.name == "Log Out" ?
                    <a style={{ textDecoration: 'none' }} href={`/`} onClick={() => props.clickDropDownItem(el.name)} className="dropdown-item-button" style={{ padding: "unset" }}>
                        <div className="dropdown-item-data">
                            <p className="dropdown-items-name">{el.name}</p>
                            <p className="dropdown-items-discription">{el.discription}</p>
                        </div>
                        <img alt="" className="dropdown-menu-arrow" src={require('../../assets/arrow_svg.svg')}></img>
                    </a> :
                    <Link style={{ textDecoration: 'none' }} to={(!elIndex == 0) ? `/${el.path}` : `/profile/details/${localStorage.getItem("username")}`} onClick={() => props.clickDropDownItem(el.name)} className="dropdown-item-button" style={{ padding: "unset" }}>
                        <div className="dropdown-item-data">
                            <p className="dropdown-items-name">{el.name}</p>
                            <p className="dropdown-items-discription">{el.discription}</p>
                        </div>
                        <img alt="" className="dropdown-menu-arrow" src={require('../../assets/arrow_svg.svg')}></img>
                    </Link>
            }
        </DropdownItem>


        )
    )
}
const NotificationsView = (props) => {
    return (
        props.notifications.map((el, elIndex) => <DropdownItem key={elIndex} value="item" >
            <Link style={{ textDecoration: 'none' }} to={`/${el.path}`} onClick={() => props.clickDropDownItem(el.name)} className="dropdown-item-button" style={{ padding: "unset" }}>
                <img src={el.artworkImg} className="notification-artwork-image-thumbnail"></img>
                <div className="dropdown-item-data" style={{ maxWidth: "70%" }}>
                    <p className="dropdown-items-name">{el.notification_heading}</p>
                    <p className="dropdown-items-discription" >{el.notification_content}</p>
                </div>
                <img alt="" className="dropdown-menu-arrow" src={require('../../assets/arrow_svg.svg')}></img>
            </Link>
        </DropdownItem>
        )
    )
}
const LoggedOutView = props => {
    if (!props.currentUser) {
        // console.log("logged out props.currentUser", props.currentUser);
        // // console.log(props.currentUser);
        return (
            <Login />
        );
    }
    return <span></span>;
};


const NewMobileView = (props) => {

    return (
        <div className="masterpieces-mobile-view-toolbar">
            <div className="masterpieces-toolbar-dropdown-container">
                <div className="masterpieces-logo-container">
                    <Link to="/" > <img style={{ paddingTop: "7%", paddingLeft: "10%", paddingRight: "10%" }} href="/" src={require('../../assets/Header_logo.png')} /></Link>
                </div>
                <div >
                    <UncontrolledDropdown nav inNavbar >
                        <DropdownToggle nav caret>
                            <img src={require('../../assets/burger-menu-icon.png')} onClick={props.handleDropdownClickDisable} className="black-menu-icon" />
                        </DropdownToggle>
                        <DropdownMenu style={{ width: "240px", display: (props.viewSecondDropdown) ? "none" : "" }}>
                            <DropdownItem >
                                <NavLink onClick={props.handleArtworksBtnClick} style={{ marginRight: "10%", 
                               
                                display: (props.viewSecondDropdown) ? "none" : "" }} className="navbar-links-artworks"><Link style={{ color: "#333333" }} onClick={props.handleArtworksBtnClick} to={localStorage.hasOwnProperty("userData") ? "/artworks" : ""}>ARTWORKS</Link></NavLink>
                            </DropdownItem>
                            <DropdownItem>
                                <NavLink style={{ display: (props.viewSecondDropdown) ? "none" : "", 
                              
                                
                                color: "#333333" }} className="navbar-links-artists" to="artists"><Link style={{ color: "#333333" }} to={localStorage.hasOwnProperty("userData") ? "/artists" : ""} onClick={props.handleArtistsBtnClick}>ARTISTS</Link></NavLink>
                            </DropdownItem>
                             <DropdownItem>
                                <NavLink style={{ display: (props.viewSecondDropdown) ? "none" : "" }}  href="http://blog.yourmasterpieces.com/"  className="navbar-links" ><a to="http://blog.yourmasterpieces.com/"
                                    target="_blank">BLOG</a></NavLink>
                            </DropdownItem> 
                            {/* <DropdownItem>
<NavLink style={{ marginRight: "50%", display: (props.viewSecondDropdown) ? "none" : "" }} className="navbar-links" >SPOTLIGHT</NavLink>
</DropdownItem > */}
                            <DropdownItem toggle={false} onClick={props.handleDropdownClick}>
                                <MobileLoggedInView viewSecondDropdown={props.viewSecondDropdown} notifications={props.notifications} clickDropDownItem={props.clickDropDownItem} currentUser={props.currentUser} clickDropDownItem={props.clickDropDownItem} dropdownItem={props.dropdownItem} />
                                <MobileLoggedOutView currentUser={props.currentUser} />
                            </DropdownItem>
                        </DropdownMenu>
                        <DropdownMenu onClick={props.handleDropdownClick} style={{ display: (props.viewSecondDropdown && localStorage.hasOwnProperty("userData")) ? "" : "none" }} className="loginDropdown">
                            <DropdownData handleDropdownClick={props.handleDropdownClick} dropdownItem={props.dropdownItem} clickDropDownItem={props.clickDropDownItem} />
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    {/* <Menu right customBurgerIcon={<img src={require('../../assets/burger-menu-icon.png')} />} >
<MobileLoggedInView notifications={props.notifications} clickDropDownItem={props.clickDropDownItem} currentUser={props.currentUser} clickDropDownItem={props.clickDropDownItem} dropdownItem={props.dropdownItem} />
<MobileLoggedOutView currentUser={props.currentUser} />
<NavLink onClick={props.handleArtworksBtnClick} style={{ marginRight: "10%" }} href="/#/artworks" className="navbar-links-artworks">ARTWORKS</NavLink>
<NavLink style={{ marginLeft: "15%" }} className="navbar-links-artists" href="/#/artists">ARTISTS</NavLink>
<NavLink style={{ marginRight: "50%" }} className="navbar-links" >BLOG</NavLink>
<NavLink style={{ marginRight: "50%" }} className="navbar-links" >SPOTLIGHT</NavLink>
{/* <a onClick={this.showSettings} className="menu-item--small" href="">Settings</a> */}
                    {/* </Menu> */}
                </div>
            </div>
            {/*<div className="masterpieces-toolbar-searchbar-container">
                <input
                    style={{ maxHeight: "36px", minHeight: "36px" }}
                    // disabled={!localStorage.hasOwnProperty("userData")} style={{ opacity: localStorage.hasOwnProperty("userData") ? 1 : 0 }}
                    onKeyDown={props.handleKeyDown} className="navbar-searchbar"
                    onChange={props.handleInputChange}
                    placeholder="Search art, artist or artstyle"></input>
                <img
                    // disabled={!localStorage.hasOwnProperty("userData")}
                    // style={{ opacity: localStorage.hasOwnProperty("userData") ? 1 : 0 }}
                    alt="" className="search-image"
                    src={require('../../assets/search_icon.png')} ></img>
            </div>*/}

            <div className="input-group search-mobile-block">
                <input type="text" className="form-control search-header-mob"
                       placeholder="Search art, artist or art styles"
                       onKeyDown={props.handleKeyDown}
                       onChange={props.handleInputChange}
                       aria-label="Recipient's username"/>
                <div className="input-group-append" onClick={props.handleSearchInput}>
                        <span className="input-group-text search-image-block-header">
                            <img alt="Search" className="search-image-new"
                                src={require('../../assets/search_icon.png')} ></img>
                        </span>
                    </div>
            </div>

        </div>
    )
}
const MobileLoggedInView = (props) => {
    if (props.currentUser)
        return (
            <div style={{ display: "flex", flex: 1, cursor: "pointer" }} >
                {/* <UncontrolledDropdown nav inNavbar style={{ flex: 1 }}>
<DropdownToggle nav caret>
<img className="notification-icon-navbar" src={(props.newNotification) ? require('../../assets/new_notification_icon_svg.svg') : require('../../assets/notification_icon_svg.svg')} />
</DropdownToggle>
<DropdownMenu className="notificationDropdown">
<NotificationsView notifications={props.notifications} clickDropDownItem={props.clickDropDownItem} />
</DropdownMenu>
</UncontrolledDropdown> */}
                <UncontrolledDropdown nav inNavbar style={{ display: "flex", flex: 4 }} >
                    <DropdownToggle nav caret>
                        <div style={{ display: "flex", }} >
                            <img alt="" className="user-photo" src={props.currentUser.image} alt="" />
                            <div className="user-name">{props.currentUser.display_name}</div>
                            <img src={require('../../assets/notification_icon copy_svg.svg')} style={{ flex: 1 }}></img>
                        </div>
                    </DropdownToggle>
                </UncontrolledDropdown>
            </div>
        )
    return <span></span>
}



const MobileLoggedOutView = props => {
    if (!props.currentUser) {
        // console.log("logged out props.currentUser", props.currentUser);
        // // console.log(props.currentUser);
        return (
            <div style={{ marginTop: "5%" }}>
                <Login />
            </div>
        );
    }
    return <span></span>;
};


// WEBPACK FOOTER //
// ./src/components/layout/toolbar_fresh.js